<script setup>
import ContinueButton from '../molecules/ContinueButton.vue';

defineProps({
  image: {
    type: String,
    required: true
  },
  heading: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  peopleImage: {
    type: String,
    required: true
  },
  peopleText: {
    type: String,
    default: ''
  },
  statsText: {
    type: String,
    default: ''
  },
  isPrimary: {
    type: Boolean,
    default: false
  },
  containerClass: {
    type: String,
  },
  alignCenter: {
    type: Boolean,
    default: false
  }
});

const getImgSrc = (imgPath) => {
  return new URL(`../../assets/images/${imgPath}`, import.meta.url).href
}
</script>
<template>
  <div class="component-container">
    <div class="component-card" :class="[containerClass, { 'primary-container': isPrimary, 'center-aligned': alignCenter }]">
      <img :src="getImgSrc(image)" class="info-img" alt="social-proof" />
      <p class="heading-4" :class="{ 'primary-color': isPrimary }">
        <span v-html="heading"></span>
      </p>
      <p class="p-md">
        {{ description }}
      </p>
      <div :class="{ 'box': isPrimary }">
        <img src="@/assets/icons/five_stars.png" alt="five-stars" width="120px" />
        <div class="other-people p-md">
          <img :src="getImgSrc(peopleImage)" alt="person" width="92px" />
          <span v-if="peopleText">{{ peopleText }}</span>
        </div>
        <p v-if="statsText" class="stats-text">{{ statsText }}</p>
      </div>
    </div>
    <ContinueButton @click="$emit('cta')"/>
  </div>
</template>

<style scoped>

.component-card {
  text-align: center;
}

.primary-container {
  background-color: var(--neutrals-0);
  border: 1px solid var(--neutrals-200);
}

.center-aligned {
  align-items: center;
}

.info-img {
  width: 100%;
}

.other-people {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  color: #737373;
}

.heading-4 {
  font-size: 32px;
  line-height: 40px;
  margin-top: 20px;
}

.primary-color {
  color: var(--primary-base);
  text-align: center;
}

.p-md {
  font-size: 16px;
  color: var(--neutrals-900);
  margin-top: 12px;
}

.stats-text {
  font-size: 14px;
  color: var(--neutrals-500);
}

.box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  /* width: 360px; */
  border-radius: 16px;
}

</style>
